<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Detalhes da Entidade</h3>
                <p>Configurações globais do sistema</p>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            Configurações do Sistema
                            <ion-badge [color]="item?.PayshopApplicationStatus === 0 ? 'warning' : 'success'">
                                {{ getPayshopStatusName(item?.PayshopApplicationStatus) }}
                            </ion-badge>
                        </ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                                    <ion-label><strong>ID:</strong> {{ item?.Id }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado em:</strong> {{ item?.CreateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado por:</strong> {{ item?.CreateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.UpdateDate">
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado em:</strong> {{ item?.UpdateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado por:</strong> {{ item?.UpdateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações do Payshop -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações do Payshop</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="card-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Estado da Aplicação:</strong> {{
                                        getPayshopStatusName(item?.PayshopApplicationStatus) }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="document-text-outline" slot="start"></ion-icon>
                                    <ion-label><strong>NIF do Payshop:</strong> {{ item?.PayshopVatNumber }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.PayshopBankAccountNumber">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="wallet-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Número de Conta Bancária:</strong> {{
                                        item?.PayshopBankAccountNumber }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de OCR -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de OCR</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="scan-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Interações Totais:</strong> {{ item?.OCRTotalItemsInteraction
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="cloud-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Limite Mensal Google Vision:</strong> {{
                                        item?.OCRGoogleCloudVisionLimitItemsMonth }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.OCRGoogleCloudVisionMode ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label><strong>Modo Google Cloud Vision:</strong> {{
                                        item?.OCRGoogleCloudVisionMode ? 'Ativo' : 'Inativo' }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.OCRTesseractMode ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label><strong>Modo Tesseract:</strong> {{ item?.OCRTesseractMode ? 'Ativo' :
                                        'Inativo' }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="shield-checkmark-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Precisão Mínima do Ficheiro:</strong> {{
                                        item?.OCRFileAccuranceMinimum }}%</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Candidaturas -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de Candidaturas</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-number-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Dias para Reclamação:</strong> {{
                                        item?.DaysToAppealInvoiceDiscount }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="cash-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Permitir Carregar Saldo da Carteira:</strong>
                                        {{ item?.AllowLoadWalletBalance ? 'Sim' : 'Não' }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Início das Candidaturas:</strong> {{
                                        item?.ApplicationSubmissionStartDate | date:'medium' }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-clear-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Fim das Candidaturas:</strong> {{
                                        item?.ApplicationSubmissionEndDate | date:'medium' }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.ApplicationSubmissionDescription">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="document-text-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Descrição das Candidaturas:</strong> {{
                                        item?.ApplicationSubmissionDescription }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Processamento -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de Processamento</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.ProcessAllBenefitsTogetherAfterFinishConsumptionsImport ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Processar Todos os Benefícios Juntos:</strong>
                                        {{ item?.ProcessAllBenefitsTogetherAfterFinishConsumptionsImport ? 'Sim' : 'Não'
                                        }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="document-attach-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Tamanho Máximo do Ficheiro:</strong> {{
                                        formatFileSize(item?.MaximumBytesFileSize) }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="mail-unread-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Email BCC para Lista de Comerciantes:</strong> {{
                                        item?.MerchantListEmailBCC || 'Não configurado' }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações do Cartão da Carteira -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações do Cartão da Carteira</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-number-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Validade em Meses:</strong> {{ item?.WalletCardValidityInMonths
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Validade em Anos:</strong> {{ item?.WalletCardValidityInYears
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Faturação -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de Faturação</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.AllowInvoiceRegistWithUnknownVatNumber ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Permitir Faturas com NIF Desconhecido:</strong>
                                        {{ item?.AllowInvoiceRegistWithUnknownVatNumber ? 'Sim' : 'Não' }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.DisableVerifyInvoiceATCUD ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Desativar Verificação ATCUD:</strong>
                                        {{ item?.DisableVerifyInvoiceATCUD ? 'Sim' : 'Não' }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Menores -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de Menores</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.HideUnderAgeHouseHoldMemberInfoForRegistListing ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Ocultar Informações de Menores:</strong>
                                        {{ item?.HideUnderAgeHouseHoldMemberInfoForRegistListing ? 'Sim' : 'Não' }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.VerifyUnderAge ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Verificar Menores:</strong>
                                        {{ item?.VerifyUnderAge ? 'Sim' : 'Não' }}
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>